import { all, takeLatest } from 'redux-saga/effects';

import { SagaHandlerRegistry } from './handlers/saga-registry';
import { clinicSaga, insuranceSaga, offerSaga, partnerSaga, resultsSaga } from './saga';

interface SagaHandler {
  actionName: string;
  saga: (action: any) => Generator<any, void, any>;
}

export default function *watchAll() {
  const sagaHandlerRegistry = new SagaHandlerRegistry();
  const actionHandlersSaga = sagaHandlerRegistry.getHandlers().map(
    (handler: SagaHandler) => takeLatest(handler.actionName, handler.saga),
  );

  yield all([
    ...clinicSaga,
    ...resultsSaga,
    ...offerSaga,
    ...partnerSaga,
    ...insuranceSaga,
    ...actionHandlersSaga,
  ]);
}
